module.exports = __webpack_public_path__ + "img/pop_xinyinghu01@2x.4fbb13e1.png";